module.exports = __webpack_public_path__ + "img/grasse_5.3614fe14.png";